import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 26"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14 .005 10.11 0C6.34 0 3.903 2.51 3.903 6.4v2.948H0v5.336h3.902L3.898 26h5.46l.004-11.316h4.478l-.004-5.335H9.362V6.847c0-1.203.284-1.811 1.843-1.811l2.783-.001z"
    }, null, -1)
  ]))]))
}
export default { render: render }